import React from 'react';
import Modal from '../Modal';
import styles from './MoveModal.module.scss';

function MoveModal({ open, onClose, children, ...rest }) {
  return (
    <Modal className={styles.moveModal} open={open} onClose={onClose} {...rest}>
      {children}
    </Modal>
  );
}

export default MoveModal;
